import React from 'react';
import { connect } from 'react-redux';
import { FullThemeStyle } from '@treelab/panda';

import SidebarEdit from './Edit';
import SidebarOptions from './Options';

import { Drawer } from '../Drawer';
import { IRootState } from '../../modules/stores';
import EditingAttachment from './Attachment';

const BAR_COLORS = [
  FullThemeStyle.blue,
  FullThemeStyle.orange,
  FullThemeStyle.green,
  FullThemeStyle.gray,
];

type IConnectProps = ReturnType<typeof mapState>;

class Sidebar extends React.Component<IConnectProps> {
  public render() {
    const { indexDepth, editingSpaceId, editingAttachment } = this.props;
    const theme = !!editingSpaceId ? BAR_COLORS[indexDepth.length % 3] : FullThemeStyle.cyan;

    return (
      <Drawer theme={theme} style={{ minWidth: 280 }}>
        <div id="main-drawer">
          {!!editingSpaceId ? (
            editingAttachment ? (
              <EditingAttachment spaceId={editingSpaceId} />
            ) : (
              <SidebarEdit spaceId={editingSpaceId} />
            )
          ) : (
            <SidebarOptions />
          )}
        </div>
      </Drawer>
    );
  }
}

const mapState = ({ space }: IRootState) => ({
  indexDepth: space.indexDepth,
  editingSpaceId: space.editingSpaceId,
  editingAttachment: space.editingAttachment,
});

export default connect(mapState)(Sidebar);
